import { useQuery } from '@tanstack/react-query';

import axiosClient from './axiosClient';

export const HAS_UNPUBLISHED_CHANGES_KEY = 'has-unpublished-changes';

/**
 * True when the tenant's home env has edits that haven't been published yet
 * (i.e. publishing would mint a new version). Backed by the publish-history
 * diff endpoint. Only enabled for the home row — callers pass `enabled` to
 * gate the probe so read-only/non-home selections don't fetch.
 */
export function useHasUnpublishedChanges(
  tenantCode: string | undefined,
  enabled: boolean,
): boolean {
  const { data } = useQuery({
    queryKey: [HAS_UNPUBLISHED_CHANGES_KEY, tenantCode],
    enabled: !!tenantCode && enabled,
    queryFn: async (): Promise<boolean> => {
      const { data } = await axiosClient.get(
        `/api/publish-history/diff?tenant=${encodeURIComponent(tenantCode as string)}`,
      );
      return Boolean(data?.hasChanges);
    },
    staleTime: 15_000,
    retry: 1,
  });
  return data === true;
}
